export default "__VITE_ASSET__C$$p4Xzi__"